import {AfterViewInit, Component, NgZone, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {GoogleMap} from '@angular/google-maps';
import rdToWgs84 from 'rd-to-wgs84';
import {ApiService} from '../../services/api/api.service';

@Component({
    selector: 'app-svg-map',
    templateUrl: './svg-map.component.html',
    styleUrl: './svg-map.component.scss'
})
export class SvgMapComponent implements OnInit, AfterViewInit {
    options: google.maps.MapOptions = {
        mapId: '55a928ad53a65407',
        center: {lat: 52, lng: 6},
        zoom: 9,
        tilt: 0,
        isFractionalZoomEnabled: false
    };
    actualZoom: number;
    @ViewChild('googleMap') googleMap: GoogleMap | undefined;
    coord: { lon: number; lat: number };
    center: { lat: number; lng: number; };
    coordEnd: { lon: number; lat: number };
    setZoom = 9;

    constructor(private ngZone: NgZone,
                private api: ApiService,
                private activeRoute: ActivatedRoute) {
    }

    ngAfterViewInit() {
        this.googleMap?.zoomChanged.subscribe((zoom) => {
            this.actualZoom = this.googleMap?.getZoom() ?? 99;
        })
    }

    ngOnInit() {
        let file = '';
        if (this.activeRoute.snapshot.params['file']) {
            file = this.activeRoute.snapshot.params['file'];
        }
        this.api.getCall$<[number, number, number, number]>('svg/map', {filename: file}).subscribe((coords) => {
            this.coord = rdToWgs84(coords[0], coords[1]);
            this.coordEnd = rdToWgs84(coords[2], coords[3]);

            setTimeout(() => {
                console.log(this.googleMap);
                if (this.googleMap) {
                    // @ts-ignore
                    this.ngZone.runOutsideAngular(() => {
                        google.maps.importLibrary('maps').then(() => {
                            this.drawOverlay(file);
                        });
                    });

                    this.center = {
                        lat: (this.coord.lat + this.coordEnd.lat) / 2,
                        lng: (this.coord.lon + this.coordEnd.lon) / 2
                    };
                    this.setZoom = 12;
                }
            });
        });

    }

    drawOverlay(file: string) {

        const bounds = new google.maps.LatLngBounds(
            {lat: this.coord.lat, lng: this.coord.lon},
            {lat: this.coordEnd.lat, lng: this.coordEnd.lon}
        );

        /**
         * The custom USGSOverlay object contains the USGS image,
         * the bounds of the image, and a reference to the map.
         */
        class USGSOverlay extends google.maps.OverlayView {
            private bounds: google.maps.LatLngBounds;
            private image: string;
            private div?: HTMLElement;

            constructor(bounds: google.maps.LatLngBounds, image: string) {
                super();

                this.bounds = bounds;
                this.image = image;
            }

            /**
             * onAdd is called when the map's panes are ready and the overlay has been
             * added to the map.
             */
            override onAdd() {
                console.log('hoi');
                this.div = document.createElement('div');
                this.div.style.borderStyle = 'none';
                this.div.style.borderWidth = '0px';
                this.div.style.position = 'absolute';

                // Create the img element and attach it to the div.
                const img = document.createElement('img');

                img.src = this.image;
                img.style.width = '100%';
                img.style.height = '100%';
                img.style.position = 'absolute';
                this.div.appendChild(img);

                // Add the element to the "overlayLayer" pane.
                const panes = this.getPanes()!;

                panes.overlayLayer.appendChild(this.div);
            }

            override draw() {
                const overlayProjection = this.getProjection();
                const sw = overlayProjection.fromLatLngToDivPixel(this.bounds.getSouthWest())!;
                const ne = overlayProjection.fromLatLngToDivPixel(this.bounds.getNorthEast())!;

                if (this.div) {
                    this.div.style.left = sw.x + 'px';
                    this.div.style.top = ne.y + 'px';
                    this.div.style.width = ne.x - sw.x + 'px';
                    this.div.style.height = sw.y - ne.y + 'px';
                }
            }

            /**
             * The onRemove() method will be called automatically from the API if
             * we ever set the overlay's map property to 'null'.
             */
            override onRemove() {
                if (this.div) {
                    (this.div.parentNode as HTMLElement).removeChild(this.div);
                    delete this.div;
                }
            }

        }

        const overlay: USGSOverlay = new USGSOverlay(bounds, 'assets/kaarten/' + file + '.svg');

        overlay.setMap(this.googleMap.googleMap);
    }

}
